import React, { useEffect, useRef, useState } from "react"
import { usePageMessageBrokerListener } from "./use_page_message_broker_listener";

// Optional: only needed if you want Turbo rendering inside the modal
import { Turbo } from "@hotwired/turbo-rails"

export default function Modal({ url, open, onClose }) {
  const [html, setHtml] = useState(null)
  const [title, setTitle] = useState(null)
  const containerRef = useRef()

  const fetchContents = () => {
    fetch(url, {
      headers: {
        Accept: "text/html",
      },
      credentials: "include",
    })
      .then((res) => res.text())
      .then((html) => {
        // Get title
        const div = document.createElement("div")
        div.innerHTML = html
        const titleEl = div.querySelector("[data-role='modal-title']")
        window.titleEl = titleEl
        if (titleEl) {
          setTitle(titleEl.innerHTML)
        }

        // Set HTML
        setHtml(html)
      })
      .catch((err) => {
        console.error("Failed to load modal content", err)
        setHtml("<p>Failed to load content</p>")
      })
  }

  useEffect(() => {
    if (open && url) {
      setHtml("")
      fetchContents()
    }
  }, [open, url])

  useEffect(() => {
    if (!html || !open) return

    const contentEl = containerRef.current.querySelector("[data-role='modal-content']")
    mountReactComponents(contentEl)
  }, [html, open]);

  usePageMessageBrokerListener('fieldValueSaved', (data) => {
    if (open && url) {
      fetchContents()
    }
  });

  //
  // Allow closing the modal when backdrop is clicked
  //
  const clickStartedInsideRef = useRef(false)

  const handleMouseDown = (e) => {
    const modalEl = containerRef.current?.querySelector(".modal-box")
    clickStartedInsideRef.current = modalEl && modalEl.contains(e.target)
  }

  const handleBackdropClick = (e) => {
    if (!clickStartedInsideRef.current && e.target === containerRef.current) {
      onClose()
    }
  }

  if (!open) return null

  return (
    <div
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onClick={handleBackdropClick}
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
    >
      <div className="modal-box bg-white rounded-lg shadow-xl px-8 pb-8 pt-0 relative" style={{maxWidth: "90vw", maxHeight: "90vh", overflowY: "auto"}}>
        <div style={{background: "red", opacity: "50%"}}></div>
        <div className="sticky top-0 left-0 right-0 bg-white z-10 px-8 h-12 flex items-center justify-between py-8 overflow-hidden border-b-0 border-gray-200" style={{ transform: "translate(-24px, 0px)", width: "calc(100% + 24px + 24px)" }}>
          <div className="whitespace-nowrap text-ellipsis" dangerouslySetInnerHTML={{ __html: title }}></div>

          <button
            onClick={onClose}
            className="text-gray-500 hover:text-black cursor-pointer"
            style={{ transform: "translateX(3px)" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="3"
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div data-role="modal-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      </div>
    </div>
  )
}
